/* +Add Ons -- Phase 8D.3A. Direct Add to Cart for the native Product
   Pages `related-products` (Product List) block on the Matching / Solo /
   Fabric PDPs, scoped entirely to `[data-pt-addons-add]` triggers inside
   `.pt-addons`. Reuses the theme's own cart-add endpoint and section-
   refresh contract (the same one assets/main.js's ProductForm uses for
   the main Add to Cart button) and the theme's own cart-drawer open
   event -- no second cart architecture, no ProductForm duplication. */
(function () {
  'use strict';

  if (typeof theme === 'undefined' || !theme.addDelegateEventListener) return;

  function setLabel(button, text) {
    var label = button.querySelector('[data-pt-addons-add-label]');
    if (label) label.textContent = text;
  }

  function addToCart(button) {
    if (button.disabled) return;

    var variantId = button.getAttribute('data-pt-addons-variant-id');
    if (!variantId) return;

    var originalLabel = button.querySelector('[data-pt-addons-add-label]');
    var originalText = originalLabel ? originalLabel.textContent : '+ Add';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.classList.add('is-loading');
    setLabel(button, 'Adding…');

    var sectionsToUpdate = ['page-header', 'cart-drawer']
      .map(function (sel) { return document.querySelector(sel); })
      .filter(Boolean);
    var sectionIds = sectionsToUpdate.map(function (el) { return el.dataset.sectionId; });

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sectionIds.join(','));

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            var message = (data && (data.description || data.message)) || 'Could not add to cart';
            throw new Error(message);
          }
          return data;
        });
      })
      .then(function (data) {
        if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
          sectionsToUpdate.forEach(function (el) {
            el.updateFromCartChange(data.sections[el.dataset.sectionId]);
          });
        } else {
          document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }

        if (document.querySelector('.js-cart-drawer')) {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', {
            bubbles: true,
            detail: { opener: button }
          }));
        }

        document.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: { variantId: data.variant_id }
        }));

        button.classList.remove('is-loading');
        button.classList.add('is-success');
        setLabel(button, 'Added');
        setTimeout(function () {
          button.classList.remove('is-success');
          button.removeAttribute('aria-busy');
          button.disabled = false;
          setLabel(button, originalText);
        }, 1600);
      })
      .catch(function (error) {
        console.log(error); // eslint-disable-line no-console
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));

        button.classList.remove('is-loading');
        button.classList.add('is-error');
        setLabel(button, 'Try again');
        button.removeAttribute('aria-busy');
        button.disabled = false;
        setTimeout(function () {
          button.classList.remove('is-error');
          setLabel(button, originalText);
        }, 2400);
      });
  }

  theme.addDelegateEventListener(document, 'click', '[data-pt-addons-add]', function (evt, el) {
    evt.preventDefault();
    addToCart(el);
  });
})();
